<template>
  <div>
    <div id="content" class="content animated slideInRight delay-1s">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <div class="card-title">
                Reservar Veículo
                <span class="required_fields">
                  <span class="required">*</span> Campos obrigatórios
                </span>
              </div>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-md-12">
                  <form action>
                    <div class="row">
                      <div
                        class="col-md-12"
                        v-if="$store.state.user.access_nivel == 1"
                      >
                        <div class="form-group">
                          <label for="carUser">
                            <span class="required">*</span> Nome do Usuário
                          </label>
                          <input
                            type="text"
                            v-model="$store.state.user.name"
                            class="form-control"
                            disabled
                          />
                        </div>
                      </div>
                      <div
                        class="col-md-12"
                        v-if="
                          $store.state.user.access_nivel == 3 ||
                          $store.state.user.access_nivel == 2 ||
                          $store.state.user.access_nivel == 4
                        "
                      >
                        <div class="form-group">
                          <label for="carUser">
                            <span class="required">*</span> Nome do Usuário
                          </label>
                          <v-select
                            :options="users"
                            label="name"
                            v-on:input="getBranches()"
                            :reduce="(users) => users.id"
                            class="style-chooser"
                            v-model="reserveVehicles.user_id"
                          >
                            <div slot="no-options">Carregando...</div>
                          </v-select>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="carDateStart">
                            <span class="required">*</span> Data de Retirada
                          </label>
                          <CtkDateTimePicker
                            v-model="reserveVehicles.RetreatDatetime"
                            color="orange"
                            locale="pt-br"
                            no-label
                            format="YYYY-MM-DD HH:mm:ss"
                            button-now-translation="Hoje"
                            class="datetimepicker"
                            label="Selecione a data e hora de retirada"
                            id="retreat_date"
                            v-on:input="closeVehiclesTable()"
                          />
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="carDateEnd">
                            <span class="required">*</span> Data de Devolução
                          </label>
                          <CtkDateTimePicker
                            v-model="reserveVehicles.DevolutionDatetime"
                            color="orange"
                            locale="pt-br"
                            no-label
                            format="YYYY-MM-DD HH:mm:ss"
                            button-now-translation="Hoje"
                            class="datetimepicker"
                            label="Selecione a data e hora de devolução"
                            id="devolution_date"
                            v-on:input="closeVehiclesTable()"
                          />
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="carType">
                            <span class="required">*</span> Justificativa
                          </label>
                          <v-select
                            v-on:input="closeVehiclesTable()"
                            :options="justifications"
                            label="description"
                            :reduce="(justifications) => justifications.id"
                            class="style-chooser"
                            v-model="reserveVehicles.justification_id"
                          >
                            <div slot="no-options">Carregando...</div>
                          </v-select>
                        </div>
                      </div>
                      <div class="col-md-6">
                        <div class="form-group">
                          <label for="reason">
                            <span class="required">*</span> Motivo da Reserva
                          </label>
                          <textarea
                            class="form-control"
                            id="reason"
                            v-model="reserveVehicles.reason"
                          ></textarea>
                        </div>
                      </div>
                      <div class="col-md-3">
                        <div class="form-group">
                          <label for="reason">
                            <span class="required">*</span> Quantos KM pretende
                            rodar?
                          </label>
                          <input
                            type="number"
                            class="form-control"
                            v-model="reserveVehicles.km_provided"
                            @change="
                              getVehicleTypes(),
                                (reserveVehicles.vehicle_type_id = '')
                            "
                            v-on:input="
                              getVehicleTypes(),
                                (reserveVehicles.vehicle_type_id = '')
                            "
                          />
                        </div>
                      </div>
                      <div class="col-md-9">
                        <div class="form-group">
                          <label for="carSpot">
                            <span class="required">*</span> Filiais
                          </label>
                          <v-select
                            v-on:input="closeVehiclesTable()"
                            :options="branches"
                            label="description"
                            :reduce="(branches) => branches.id"
                            class="style-chooser"
                            v-model="reserveVehicles.branch_id"
                          >
                            <div slot="no-options">
                              Nenhuma filial vinculada
                            </div>
                          </v-select>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-group">
                          <label for="carType">
                            <span class="required">*</span> Tipo do Veículo
                          </label>
                          <v-select
                            v-on:input="closeVehiclesTable()"
                            :options="vehicleTypes"
                            label="description"
                            :reduce="(vehicleTypes) => vehicleTypes.id"
                            class="style-chooser"
                            v-model="reserveVehicles.vehicle_type_id"
                          >
                            <div slot="no-options">Carregando...</div>
                          </v-select>
                        </div>
                      </div>
                      <div class="col-md-4">
                        <div class="form-group">
                          <label for="carPlate">
                            <span class="required">*</span> Status da Reserva
                          </label>
                          <select
                            v-model="reserveVehicles.reserve_status"
                            class="form-control"
                            disabled
                          >
                            <option
                              v-for="status in reserveVehiclesStatus"
                              :value="status.id"
                              :key="status.id"
                            >
                              {{ status.title }}
                            </option>
                          </select>
                        </div>
                      </div>
                      <div class="col-md-2" style="padding: 22px">
                        <div class="form-group" align="right">
                          <a
                            class="btn btn-add"
                            @click="getVehicles($store.state.user.access_nivel)"
                          >
                            Pesquisar Veículos
                            <i class="fa fa-car"></i>
                          </a>
                        </div>
                      </div>
                    </div>
                    <br />
                    <div class="row" align="right">
                      <div class="col-md-12">
                        <a class="btn btn-add" @click="save">
                          Salvar
                          <i class="fa fa-save"></i>
                        </a>
                        <router-link to="/reserveVehicles" class="btn btn-back">
                          <i class="fa fa-arrow-left"></i> Voltar
                        </router-link>
                      </div>
                    </div>
                    <div class="row d-flex justify-content-center">
                      <div
                        v-if="loaded > 0"
                        class="col-md-12"
                        style="padding: 1%"
                      >
                        <div
                          v-if="loaded == 0"
                          class="col-md-12"
                          style="padding: 1%"
                          align="center"
                        >
                          <i
                            class="fas fa-circle-notch fa-spin"
                            style="font-size: 35px"
                          ></i>
                        </div>

                        <table
                          v-else-if="
                            $store.state.user.access_nivel == 3 ||
                            $store.state.user.access_nivel == 2 ||
                            $store.state.user.access_nivel == 4
                          "
                          class="table table-hover"
                        >
                          <thead>
                            <tr>
                              <th scope="col"></th>
                              <th scope="col">Veículo</th>
                              <th scope="col">Placa</th>
                              <th scope="col">Rodízio</th>
                              <th scope="col">KM</th>
                              <th scope="col">Selecione</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="(vehicle, index) in vehicles"
                              :key="vehicle.id"
                            >
                              <td>
                                <button
                                  type="button"
                                  class="btn btn-crud view"
                                  @click="modalVeiculo(index)"
                                >
                                  <i class="far fa-eye"></i>
                                </button>
                              </td>
                              <td>{{ vehicle.description }}</td>
                              <td>{{ vehicle.board }}</td>
                              <td>
                                {{
                                  vehicle.vehicle_caster
                                    ? vehicle.vehicle_caster.day_week
                                    : ""
                                }}
                              </td>
                              <td>{{ vehicle.current_km }}</td>
                              <td>
                                <input
                                  type="radio"
                                  :value="vehicle.id"
                                  v-model="reserveVehicles.vehicle_id"
                                  id="vehicle_id"
                                />
                              </td>
                            </tr>

                            <tr
                              v-if="loaded > 0 && vehiclesCount == 0"
                              align="center"
                            >
                              <td colspan="7" align="center">
                                Não há veículos disponíveis nessas condições.
                              </td>
                            </tr>
                          </tbody>
                        </table>

                        <div
                          v-else
                          id="container"
                          align-content="center"
                          class="col-md-12"
                          v-show="$store.state.user.access_nivel == 1"
                        >
                          <label
                            class="d-flex justify-content-center"
                            for="vehicleSelect"
                            >Escolha seu veículo:</label
                          >
                          <br />
                          <div class="row d-flex justify-content-center">
                            <div
                              id="vehicleSelect"
                              v-for="(vehicle, index) in vehicles"
                              :key="vehicle.id"
                              style="width: 90px"
                              class="mix col-xl-3 col-lg-3 col-md-4 col-sm-6"
                            >
                              <a
                                href
                                @click="
                                  selectVehicle(
                                    index + 1,
                                    vehicle.id,
                                    vehicles.length
                                  )
                                "
                                data-toggle="modal"
                                data-target="#modalReservado"
                              >
                                <div :id="index + 1" class="card-car">
                                  <div class="badge-car"></div>
                                  <img
                                    class="img-car2"
                                    :src="vehicle.photo"
                                    alt
                                  />
                                  <div class="car-plate1">
                                    Veículo:
                                    <span>
                                      {{ vehicle.model }}
                                      {{ vehicle.color }}
                                    </span>
                                  </div>
                                  <div class="car-plate1">
                                    Placa:
                                    <span>{{ vehicle.board }}</span>
                                  </div>
                                  <div class="car-km1">
                                    Km:
                                    <span>{{ vehicle.current_km }} km</span>
                                  </div>
                                </div>
                              </a>
                            </div>
                          </div>
                        </div>
                      </div>
                      <br />
                      <br />
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal Moderação -->
    <div
      class="modal fade"
      id="modalVeiculo"
      tabindex="-1"
      v-if="opModal > 0"
      role="dialog"
      aria-labelledby="modalVeiculoTitle"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="modalVeiculoTitle">
              Informações do Veículo
            </h5>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-5">
                <img class="car-pic" :src="vehicles[indexs].photo" alt />
              </div>
              <div class="col-md-7">
                <div class="car-info">
                  <div class="car-desc">
                    <div class="text">{{ vehicles[indexs].description }}</div>
                    <div class="data">{{ vehicles[indexs].board }}</div>
                    <div class="clearfix"></div>
                  </div>
                  <div class="car-desc">
                    <div class="text">Ano Modelo:</div>
                    <div class="data">{{ vehicles[indexs].model_year }}</div>
                    <div class="clearfix"></div>
                  </div>
                  <div class="car-desc">
                    <div class="text">Combustível:</div>
                    <div class="data">{{ vehicles[indexs].combustible }}</div>
                    <div class="clearfix"></div>
                  </div>
                  <div class="car-desc">
                    <div class="text">Marca:</div>
                    <div class="data">{{ vehicles[indexs].brand }}</div>
                    <div class="clearfix"></div>
                  </div>
                  <div class="car-desc">
                    <div class="text">Cor:</div>
                    <div class="data">{{ vehicles[indexs].color }}</div>
                    <div class="clearfix"></div>
                  </div>
                  <div class="car-desc">
                    <div class="text">Km Rodados:</div>
                    <div class="data km-total">
                      <the-mask
                        disabled
                        class="km-in-modal"
                        :value="this.vehicles[indexs].current_km"
                        :mask="['####', '#.###', '##.###', '###.###']"
                      />
                    </div>
                    <div class="clearfix"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
  </div>
</template>

<script>
import BaseCrud from "../Base/BaseCrud";
import vSelect from "vue-select";
import CtkDateTimePicker from "vue-ctk-date-time-picker";

// Import component
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  data() {
    return {
      selectedVehicle: "0",
      isLoading: false,
      fullPage: true,
      value2: null,
      indexs: "",
      now: "",
      loaded: 0,
      opModal: 0,
      reserveVehicles: {
        count: 0,
        user_id: "",
        RetreatDatetime: "",
        DevolutionDatetime: "",
        retreat_date: "",
        devolution_date: "",
        reason: "",
        branch_id: "",
        vehicle_type_id: "",
        vehicle_id: "",
        reserve_status: "2",
        showVehicles: false,
        justification_id: "",
        km_provided: "",
      },
      users: [],
      branches: [],
      vehicleTypes: [],
      justifications: [],
      vehicles: [
        {
          photo: "",
          description: "",
        },
      ],
      vehiclesCount: 0,
      reserveVehiclesStatus: [],
      reserveVehiclesParameters: [],
    };
  },
  filters: {
    brDate(text) {
      if (text != "" && text != "null" && text != null) {
        // aaaa-mm-dd

        let date = text.split("-");

        return date[2] + "/" + date[1] + "/" + date[0];
      }

      return "";
    },
  },
  computed: {},
  methods: {
    modalVeiculo(id) {
      const self = this;
      self.indexs = id;
      self.opModal = 1;

      $("#modalVeiculo").modal({ show: true });
    },

    selectVehicle(id, id_vehicle, count) {
      $("div").removeClass("card-car-selected");
      document.getElementById("1").classList.add("card-car");
      if (count == 2) {
        document.getElementById("2").classList.add("card-car");
      }
      document.getElementById(id).classList.remove("card-car");
      document.getElementById(id).classList.add("card-car-selected");

      this.reserveVehicles.vehicle_id = id_vehicle;
    },

    makeFormData: function () {
      const self = this;
      let fd = new FormData();

      let vehicle_id = document.getElementById("vehicle_id");

      if (self.$store.state.user.access_nivel == 1) {
        fd.append("user_id", self.$store.state.user.id);
      } else {
        fd.append("user_id", self.reserveVehicles.user_id);
      }

      fd.append("retreat_date", self.reserveVehicles.RetreatDatetime);
      fd.append("devolution_date", self.reserveVehicles.DevolutionDatetime);
      fd.append("reason", self.reserveVehicles.reason);
      fd.append("branch_id", self.reserveVehicles.branch_id);
      fd.append("vehicle_type_id", self.reserveVehicles.vehicle_type_id);
      fd.append("vehicle_id", self.reserveVehicles.vehicle_id);
      fd.append("reserve_status", self.reserveVehicles.reserve_status);
      fd.append("justification_id", self.reserveVehicles.justification_id);
      fd.append("km_provided", self.reserveVehicles.km_provided);

      if (self.reserveVehicles.id) {
        fd.append("id", self.reserveVehicles.id);
        fd.append("_method", "PUT");
      }

      return fd;
    },
    save: function () {
      this.isLoading = true;

      const self = this;
      let api = self.$store.state.api + "reserveVehicles";

      let fd = self.makeFormData();

      if (self.reserveVehicles.id) {
        api += "/" + self.reserveVehicles.id;
      }

      self.$http
        .post(api, fd)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          this.$router.push("/reserveVehicles");
        })
        .catch((error) => {
          this.isLoading = false;
          self.$message(null, error.response.data, "error");
        });
    },
    getReserveVehicles: function (id) {
      const self = this;
      const api =
        self.$store.state.api +
        "reserveVehicles/" +
        id +
        "/?with[]=reserve_status";

      self.$http
        .get(api)
        .then((response) => {
          self.reserveVehicles = response.data.data[0];
          console.log( self.reserveVehicles );
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getUsers: function (id) {
      const self = this;
      const api =
        self.$store.state.api + "users_available_to_reserve/?paginated=false";

      self.$http
        .get(api)
        .then((response) => {
          self.users = response.data.data;
          self.getBranches();
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getBranches: function () {
      const self = this;
      const api =
        self.$store.state.api +
        "users/" +
        self.$store.state.user.id +
        "/?with[]=branches";

      self.$http
        .get(api)
        .then((response) => {
          self.branches = response.data.data[0].branches;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getJustifications: function (id) {
      const self = this;
      const api = self.$store.state.api + "justifications/";

      self.$http
        .get(api)
        .then((response) => {
          self.justifications = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getVehicleTypes: function (id) {
      const self = this;
      const api = self.$store.state.api + "vehicleTypes/filter";

      self.$http
        .post(api, { km_provided: self.reserveVehicles.km_provided })
        .then((response) => {
          self.vehicleTypes = response.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getVehicles: function (access_nivel) {
      const self = this;

      if (access_nivel == 3 || access_nivel == 4) {
        var route = "vehiclesAvailable/";
      } else {
        var route = "vehiclesAvailableMobile/";
      }

      const api = self.$store.state.api + route;

      var date1 = new Date(this.reserveVehicles.DevolutionDatetime);
      var date2 = new Date(this.reserveVehicles.RetreatDatetime);
      var timeDiff = Math.abs(date2.getTime() - date1.getTime());
      var diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));

      let fd = new FormData();

      fd.append("_method", "GET");
      fd.append("retreat_date", self.reserveVehicles.RetreatDatetime);
      fd.append("devolution_date", self.reserveVehicles.DevolutionDatetime);
      fd.append("vehicle_type_id", self.reserveVehicles.vehicle_type_id);
      fd.append("reason", self.reserveVehicles.reason);

      if (self.$store.state.user.access_nivel == 1) {
        fd.append("user_id", self.$store.state.user.id);
      } else {
        fd.append("user_id", self.reserveVehicles.user_id);
      }

      fd.append("branch_id", self.reserveVehicles.branch_id);
      fd.append("request_origin", "WEB");

      self.$http
        .post(api, fd)
        .then((response) => {
          self.vehicles = response.data.data;
          self.vehiclesStatus = response.data.reserve_status;
          self.vehiclesCount = response.data.count;
          self.loaded = response.data.loaded;

          if (self.vehiclesStatus == 1) {
            this.reserveVehicles.reserve_status = 1;
            this.$message(
              "Atenção",
              "Sua reserva superou o limite de " +
                self.reserveVehiclesParameters[0].max_days +
                " dias, ela será remetida a aprovação do gestor.",
              "warning"
            );
          } else {
            this.reserveVehicles.reserve_status = 2;
          }
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getReserveVehiclesStatus: function (id) {
      const self = this;
      const api = self.$store.state.api + "reserveVehiclesStatus/";

      self.$http
        .get(api)
        .then((response) => {
          self.reserveVehiclesStatus = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getReserveVehiclesParameters: function () {
      const self = this;
      const api = self.$store.state.api + "reserveVehiclesParameters/1";

      self.$http
        .get(api)
        .then((response) => {
          self.reserveVehiclesParameters = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    closeVehiclesTable: function () {
      this.loaded = "";
      this.vehicles = "";
      this.reserveVehicles.vehicle_id = "";
      this.reserveVehicles.showVehicles = false;
    },
  },
  mounted: function () {
    const self = this;
    var data = new Date(),
      dia = data.getDate().toString(),
      diaF = dia.length == 1 ? "0" + dia : dia,
      mes = (data.getMonth() + 1).toString(), //+1 pois no getMonth Janeiro começa com zero.
      mesF = mes.length == 1 ? "0" + mes : mes,
      anoF = data.getFullYear();
    data = anoF + "-" + mesF + "-" + diaF;

    self.now = data.toString();

    self.getUsers();
    self.getJustifications();
    // self.getVehicleTypes();
    self.getReserveVehiclesStatus();
    self.getReserveVehiclesParameters();

    let id = self.$route.params.id;
    if (id) {
      self.getReserveVehicles(id);
    }

    jQuery(document).ready(function () {
      jQuery(".multipleSelect").chosen({
        disable_search_threshold: 10,
        no_results_text: "Sem resultado.",
        width: "100%",
      });
    });
  },

  props: {},
  components: {
    BaseCrud,
    vSelect,
    CtkDateTimePicker,
    Loading,
  },
};
</script>
<style scoped>
.top {
  margin-top: 10px;
}
select {
  -webkit-appearance: none;
  -moz-appearance: none;
  text-indent: 1px;
  text-overflow: "";
}
</style>



// WEBPACK FOOTER //
// src/components/ReserveVehicles/Add.vue